"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.remoteVesselList = remoteVesselList;
exports.vesselInfoSearch = vesselInfoSearch;
var _request = _interopRequireDefault(require("@/utils/request"));
// 船舶名称远程搜索

function remoteVesselList(query) {
  return (0, _request.default)({
    url: '/equery/vocVessel/remoteVesselList',
    method: 'post',
    params: query
  });
}

// 船舶信息查询

function vesselInfoSearch(query) {
  return (0, _request.default)({
    url: '/equery/vocVessel/vesselInfoSearchEC',
    method: 'post',
    params: query
  });
}